import { AdvanceOrderStatus, PixKeyType, TravelerAdvance } from "~/application/types";
import { TravelerAdvanceDTO } from "../dtos";
import { mapTravelerDTO } from "./mapTravelerDTO";
import { toDate } from "~/application/utils/date-functions";
import { mapCardTransactionDTO } from "./mapCardTransactionDTO";
import { mapExpenseCardDTO } from "./mapExpenseCardDTO";

export function mapTravelerAdvanceDTO(data: TravelerAdvanceDTO): TravelerAdvance {
  return {
    uuid: data.uuid,
    order: {
      uuid: data.order?.uuid,
      orderNumber: data?.order?.order_number,
      travelers: (data.order?.travelers || []).map(mapTravelerDTO),
    },
    status: data.status as AdvanceOrderStatus,
    createdAt: data.created_at,
    advanceNumber: data.advance_number,
    traveler: data.traveler ? mapTravelerDTO(data.traveler) : null,
    description: data.description,
    currentApprover: data.current_approver,
    costCenter: data.cost_center && {
      uuid: data.cost_center.uuid,
      name: data.cost_center.name,
    },
    project: data.project && {
      uuid: data.project.uuid,
      name: data.project.name,
    },
    phase: data.phase && {
      uuid: data.phase.uuid,
      name: data.phase.name,
    },
    issuer: data.issuer,
    approvedBy: data.approved_by,
    approvalRequestDate: data.approval_request_date,
    reasonExpense: {
      uuid: data.reason_expense?.uuid,
      reason: data.reason_expense?.name,
    },
    expenses: data?.expenses?.map((expense) => ({
      createdAt: expense.created_at,
      value: expense.value,
    })),
    value: data.value,
    approvalModel: {
      approvers: (data.approval_model?.approvers || []).map((data) => ({
        uuid: data?.uuid,
        level: data?.level,
        name: data?.name,
        approvalStatus: data?.approval_status,
        isSelfApprover: data?.self_approver,
      })),
      uuid: data?.approval_model?.uuid,
    },
    dateOfNeed: toDate(data.date_of_need),
    paymentReceiptUrl: data.payment_receipt_url,
    reasonRejected: data.reason_rejected,
    cardTransactions: data.card_transactions
      ? data.card_transactions.map(mapCardTransactionDTO)
      : [],
    pixKey: data.pix_key,
    pixType: Object.values(PixKeyType).includes(data.pix_type as PixKeyType)
      ? (data.pix_type as PixKeyType)
      : undefined,
    bankInstitution: data.bank_institution,
    cardTransaction: data.card_transaction ? mapCardTransactionDTO(data.card_transaction) : null,
    card: data.card ? mapExpenseCardDTO(data.card) : undefined,
  };
}
